/**
 * This file handles the wavy arrows on the homepage
 */

import {gsap} from 'gsap';

( function() {

	function createArrows() {

		// Find all of the arrow svgs
		const pageLinks = document.querySelectorAll('.page-link-link');

		// Determine how many points we will add to the poly line

		if(pageLinks.length > 0) {

			const	numPoints = 130;

			Array.from(pageLinks).forEach((link) => {

				const	svg = link.querySelectorAll('.wavy-arrow')[0];

				// target the nested poly element for each svg
				const poly = svg.querySelector('.wavy-poly');

				for(let i = 0; i < numPoints; i++) {

					// Create a new point and add it to the poly line
					const p = poly.points.appendItem(svg.createSVGPoint());

					p.x = 10 + (i * 1.5); // Spread the x-axis points out evenly
					p.y = 55; // Keep them all on the same y-axis

				}

				// create a gsap timeline and play it backwards
				// We want it looking like it's waving from the right to the left
				const tlHover = gsap.timeline({paused: true});

				const points = Array.from(poly.points);

				points.forEach((point, i) => {

					const y = Math.sin(i * 0.1) * 7;

					tlHover.to(point, {
						y: `+=${ y }`,
						x: `+=20`,
						duration: 0.3,
						ease: 'sine.inOut'
					}, 0);

				});

				// trigger the animation on mouse enter
				link.addEventListener('mouseenter', () => {
					tlHover.play();
				});

				// revert the animation on mouse leave
				link.addEventListener('mouseleave', () => {
					tlHover.reverse();
				});

				// revert the animation on mouse leave
				link.addEventListener('mouseout', () => {
					tlHover.reverse();
				});

			});

		}

	}

	createArrows();

}() );
